import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'townip-option',
  templateUrl: './option.component.html',
  styleUrls: ['./option.component.scss']
})
export class OptionComponent implements OnInit {

  @Input()
  public value: any;

  @Input()
  public label: string;

  constructor() { }

  public ngOnInit(): void {
  }

}
